import type { I18nLanguage } from './types';

export const DEFAULT_I18N_LANGUAGE: I18nLanguage = 'en-GB';
export const NATIVE_LANGUAGE_DISPLAY_NAMES: Record<I18nLanguage, string> = {
  'de-DE': 'Deutsch',
  'en-GB': 'English',
  'es-ES': 'Español',
  'it-IT': 'Italiano',
  'pl-PL': 'Polski',
  'ro-RO': 'Română',
  'sr-RS': 'Srpski',
};

export const I18N_LANGUAGE_ALIASES: Record<string, I18nLanguage> = {
  de: 'de-DE',
  'de-de': 'de-DE',
  en: 'en-GB',
  'en-gb': 'en-GB',
  es: 'es-ES',
  'es-es': 'es-ES',
  it: 'it-IT',
  'it-it': 'it-IT',
  pl: 'pl-PL',
  'pl-pl': 'pl-PL',
  ro: 'ro-RO',
  'ro-ro': 'ro-RO',
  sr: 'sr-RS',
  'sr-rs': 'sr-RS',
};
